<template>
  <div class="box-voice">
    <div class="voice-header m-b-10">
      <div>
        <v-icon>fa-comment-dots</v-icon>
        <span class="m-l-5">Push Message</span>
      </div>
      <div>
        <v-icon small class="m-l-5" @click="deletePrompt">
          fa-times-circle
        </v-icon>
      </div>
    </div>
    <v-textarea
      v-model="prompt.text"
      label="Enter text output"
      class="textarea-input no-drag"
      solo
      hide-details
      rows="2"
      row-height="20"
    ></v-textarea>
  </div>
</template>

<script>
export default {
  name: 'PayloadText',
  props: {
    index: Number,
    prompt: Object,
    minioHost: String,
    items: Array,
    isMainPlaying: Boolean
  },
  methods: {
    deletePrompt() {
      this.$emit('deletePrompt', this.index)
    }
  }
}
</script>

<style scoped lang="scss">
.box-voice {
  background-color: #f7f7f7;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ebebeb;
}
.voice-header {
  display: flex;
  justify-content: space-between;
}
</style>
